import isEqualWith from 'lodash/isEqualWith';
import { getAvaliblePaymentMethods } from './commonUtils';
import { amountSum } from '../../../../../../shared/utils/commonUtils';
import getCurrentAmountAndCreditBalance from '../../../../../../shared/utils/currentAmountAndCreditBalance/getCurrentAmountAndCreditBalance';

const setSupportPaymentMethodsState = (state, action) => {
  const {
    entities: {
      paymentOptionData: { paymentOptions },
    },
    currentPaymentOptionType,
    isPayManual,
    isPayInfull,
    useCreditBalance,
    updateBillingSchedule,
    supportPaymentMethods,
    amountDue,
    paymentProcessingFee,
    creditBalance,
  } = state;
  const { currentAmountDue } = getCurrentAmountAndCreditBalance({
    useCreditBalance,
    creditBalance,
    currentTotalAmount: amountDue,
    thirdPartyAmount: action.payload.thirdPartyAmount,
  });
  const paymentAmount = amountSum(currentAmountDue, paymentProcessingFee);
  const supportSubOptionConfig = {
    APPLY_CREDIT_BALANCE: useCreditBalance,
    UPDATE_BILLING_SCHEDULE: updateBillingSchedule,
  };
  const avalibleMethods = getAvaliblePaymentMethods({
    paymentOptions,
    currentActiveOption: currentPaymentOptionType,
    supportSubOptionConfig,
    paymentAmount,
    payManual: isPayManual,
    payInFull: isPayInfull,
  });

  if (!isEqualWith(supportPaymentMethods, avalibleMethods)) {
    state.supportPaymentMethods = avalibleMethods;
  }
};

export default setSupportPaymentMethodsState;
